const CustomColors = {
    colors: {
        primary: "#004896",
        darkBlue: "#004896",
        babyBlue: "#E1F3FF",
        lightPurple: "#f2f8ff"
    },
}

export default CustomColors